@if(error) {
  <div class="alert alert-danger">{{error}}</div>
}
<h1>
  <span>Bulk import RIDs</span>
</h1>
<form name="importSetup" class="form-horizontal">
  <h4> <span>Select an existing market context's operator/program or enter the operator/program explicitly.</span> </h4>
  <div class="form-group">
    <label for="setup_market_context"> Existing Market Context</label>
    <select name="setup_market_context" id="setup_market_context" class="form-control" type="select"
            (change)="useMarketContext($event.target)">
      <option disabled selected value></option>
      @for(mc of market_contexts; track mc) {
        <option [value]="mc.id">{{mc.market_context}} ({{mc.operator}}: {{mc.program}})</option>
      }
    </select>
  </div>

  <div class="form-group">
    <label for="metadataReportDataSource">Data source: </label>
    <select id="metadataReportDataSource" class="form-control" name="data_source" type="text" (change)="useDataSource($event.target)" required>
      <option disabled selected value></option>
      <option value="kpx">KPX</option>
      <option value="enbala">ENBALA</option>
      <option value="japan">JAPAN</option>
      <option value="x-energy">X-ENERGY</option>
      <option value="static">STATIC</option>
      <option value="tva">TVA</option>
      <option value="basic">BASIC</option>
    </select>

  </div>

  @if(setup.data_source === 'x-energy') {
    <div class="form-group">
      <label for="importBy">Import by: </label>
      <select id="importBy" class="form-control" name="import_by" type="text" [formControl]="importSetup.controls.importBy" (change)="useImportBy($event.target)" required="setup.data_source === 'x-energy'">
        <option value="PRODUCT">Product</option>
        <option value="PORTFOLIO">Portfolio</option>
      </select>
    </div>
  }

  <div class="form-group">
    <label for="setup_operator"> Operator</label>
    <input name="setup_operator" id="setup_operator" class="form-control" type="text" [formControl]="importSetup.controls.operator" />

    <label for="setup_program"> Program</label>
    <input name="setup_program" id="setup_program" class="form-control" type="text" [formControl]="importSetup.controls.program" />
  </div>
  @if(setup.data_source === 'x-energy') {
    <div class="form-group">
      <label for="setup_product" *ngIf="setup.by == 'PRODUCT'"> Product</label>
      <label for="setup_product" *ngIf="setup.by == 'PORTFOLIO'"> Portfolio</label>
      <input name="setup_product" *ngIf="setup.by" id="setup_product" class="form-control" type="text" [formControl]="importSetup.controls.setup" required="setup.data_source === 'x-energy'"/>
    </div>
  }
  <button id="setup" class="btn btn-primary" type="button" (click)="setupData()">Load Meters</button>

</form>
<br><br>
@if(isSetup){
  <form name="ridForm" class="form-horizontal">
    <div>
      <label for="displayed_potential_rids">MRIDs:</label>
      <table id="displayed_potential_rids" class="table table-striped">
        <thead>
        <tr>
          <th colspan="8">
            <input name="search" placeholder="Search" class="input-sm form-control" type="search" [(ngModel)]="searchText" [ngModelOptions]="{standalone: true}" />
          </th>
        </tr>
        <tr>
          <th>
            <div class="row no-gutter">
              <div class="col-sm-6"><button id="included_all" class="btn btn-primary btn-sm" style="width: 100%" type="button" (click)="applyAll('included')">All</button></div>
              <div class="col-sm-6"><button id="included_none" class="btn btn-primary btn-sm" style="width: 100%" type="button" (click)="clearAll('included')">None</button></div>
            </div>
          </th>
          <th></th>
          <th></th>
          <th></th>
          <th>
            <div class="row">
              <div><input name="market_context_all_input" id="market_context_all_input" type="text" style="width: auto" class="form-control" [(ngModel)]="all.market_context" [ngModelOptions]="{standalone: true}"></div>
            </div>
            <div class="row">
              <div class="col-sm-6"><button id="market_context_apply" class="btn btn-primary" style="width: 100%" type="button" (click)="applyAll('market_context')">Apply</button></div>
              <div class="col-sm-6"><button id="market_context_clear" class="btn btn-primary" style="width: 100%" type="button" (click)="clearAll('market_context')">Clear</button></div>
            </div>
          </th>
          <th>
            <div class="row">
              <div><input name="resource_all_input" id="resource_all_input" type="text" style="width: auto" class="form-control" [(ngModel)]="all.resource" [ngModelOptions]="{standalone: true}"></div>
            </div>
            <div class="row">
              <div class="col-sm-6"><button id="resource_apply" class="btn btn-primary" style="width: 100%" type="button" (click)="applyAll('resource')">Apply</button></div>
              <div class="col-sm-6"><button id="resource_clear" class="btn btn-primary" style="width: 100%" type="button" (click)="clearAll('resource')">Clear</button></div>
            </div>
          </th>
          <th>
            <div class="row">
              <div>
                <select name="power_type_all_input" id="power_type_all_input" style="width: auto" class="form-control input-sm" type="select" (change)="powerType($event.target)">
                  <option disabled selected value></option>
                  @for(cp of channel_powertypes; track cp) {
                    <option [value]="cp.uuid">{{cp.conversion?.description}} -- {{cp.powertype?.itemDescription}} ({{cp.powertype?.itemUnit}}{{cp.powertype?.siScaleCode}}) {{cp.powertype?.hertz}}Hz {{cp.powertype?.voltage}}V</option>
                  }
                </select>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6"><button id="power_type_apply" class="btn btn-primary" style="width: 100%" type="button" (click)="applyAll('power_type')">Apply</button></div>
              <div class="col-sm-6"><button id="power_type_clear" class="btn btn-primary" style="width: 100%" type="button" (click)="clearAll('power_type')">Clear</button></div>
            </div>
          </th>
          <th>
            <div class="row">
              <div>
                <select multiple name="metadata_reports_all_input" id="metadata_reports_all_input" style="width: auto" class="form-control input-sm" type="select" (change)="metada($event.target)">
                  @for(metadata_report of metadata_reports | searchFilterPipe : setup.data_source : 'data_source'; track metadata_report) {
                    <option [value]="metadata_report.id">{{metadata_report.report_specifier_id}}</option>
                  }
                </select>
              </div>

            </div>
            <div class="row">
              <div class="col-sm-6"><button id="metadata_reports_apply" class="btn btn-primary" style="width: 100%" type="button" (click)="applyAll('metadata_reports')">Apply</button></div>
              <div class="col-sm-6"><button id="metadata_reports_clear" class="btn btn-primary" style="width: 100%" type="button" (click)="clearAll('metadata_reports')">Clear</button></div>
            </div>
          </th>
        </tr>
        <tr>
          <th>Included</th>
          <th>ID</th>
          <th>External id</th>
          <th>Division</th>
          <th>Display Label</th>
          <th>Market Context</th>
          <th>Resource</th>
          <th>Power Type</th>
          <th>Metadata Report</th>
        </tr>
        </thead>
        <tbody>
          @for(rid of displayed_potential_rids | searchFilterPipe : searchText : 'mrid'; track rid) {
            <tr>
              <td>
                <input name="included" id="{{rid.mrid}}_included" class="form-check-input" type="checkbox" [(ngModel)]="rid.included" (change)="includedRids(rid, $event.target)">
              </td>
              <td>{{rid.mrid}}</td>
              <td>{{rid.external_id}}</td>
              <td>{{rid.division}}</td>
              <td>{{rid.display_label}}</td>
              <td>
                <input name="market_context" id="{{rid.mrid}}_market_context" class="form-control" type="text" [(ngModel)]="rid.market_context">
              </td>
              <td>
                <input name="resource" id="{{rid.mrid}}_resource" class="form-control" type="text" [(ngModel)]="rid.resource">
              </td>
              <td>
                <select name="power_type" id="{{rid.mrid}}_power_type" class="form-control input-sm" type="select" [(ngModel)]="rid.power_type">
                  <option disabled selected value></option>
                  @for(cp of (rid.channel_id ? channels_map[rid.channel_id] : channel_powertypes); track cp) {
                    <option [value]="cp.uuid">{{cp.conversion?.description}} -- {{cp.powertype?.itemDescription}} ({{cp.powertype?.itemUnit}}{{cp.powertype?.siScaleCode}}) {{cp.powertype?.hertz}}Hz {{cp.powertype?.voltage}}V</option>
                  }
                </select>
              </td>
              <td>
                <select multiple name="metadata_reports" id="{{rid.mrid}}_metadata_reports" class="form-control" type="select" [(ngModel)]="rid.metadata_reports">
                  @for(metadata_report of metadata_reports | searchFilterPipe : setup.data_source : 'data_source'; track metadata_report) {
                    <option [ngValue]="metadata_report.id" [selected]="metadaSelected.includes(metadata_report.id)">{{metadata_report.report_specifier_id}}</option>
                  }
                </select>
              </td>
            </tr>
          }
          @if(displayed_potential_rids.length <= 0) {
            <tr>
              <td colspan="8" style="text-align: center;"> No new RIDs available.</td>
            </tr>
          }
        </tbody>
        <tfoot>
        <tr><td class="text-center" colspan="8"><div></div></td></tr>
        </tfoot>
      </table>
    </div>

    <div class="alert alert-info" role="alert" *ngIf="status && status !== 'Waiting.'">{{status}}</div>

    <button id="save" class="btn btn-primary" type="button" (click)="save()">Save</button>
    <a class="btn" (click)="backPage('/rids', router)">Cancel</a>
  </form>
}
